import ROUTES from '../../components/Routes/constants';
import COUNTRY_CODES from '../types/countryCodes';

const filterNavItems = (
  items,
  authLoginResponse,
  isDMPCheckoutEnabled = false
) => {
  const canCreateOrSell = () => authLoginResponse?.user?.isCanSell;
  const canBuy = () => authLoginResponse?.user?.isCanBuy;

  return items.filter(({ linkTo }) => {
    switch (linkTo) {
      case ROUTES.CREATE:
        return canCreateOrSell();
      case ROUTES.SELLING:
        return canCreateOrSell();
      case ROUTES.BUYING_CLOSING:
        return authLoginResponse?.user?.country?.id === COUNTRY_CODES.CA;
      case ROUTES.BUYING_WON:
      case ROUTES.BUYING_ARRIVED:
      case ROUTES.BUYING_DELIVERED:
        return !isDMPCheckoutEnabled;
      case ROUTES.BUYING_PURCHASE:
        return isDMPCheckoutEnabled && canBuy();
      default:
        return true;
    }
  });
};

export default filterNavItems;
